'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // Scroll Add header class
    var $siteHeader = $('#site-header');
    var transparentClass = 'transparent-header';
    var hasTransparentHeader = false;
    if ($siteHeader.hasClass(transparentClass)) hasTransparentHeader = true;
    function checkScroll() {
        var scrollPosition = $(window).scrollTop();
        var scrollThreshold = 50;
        if (scrollPosition < scrollThreshold) {
            $siteHeader.addClass(transparentClass);
        } else {
            $siteHeader.removeClass(transparentClass);
        }
    }
    if (hasTransparentHeader) {
        checkScroll();
        $(window).scroll(function () {
            checkScroll();
        });
    }
};